import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['James M.', 'Coach David', 'Priya T.', 'Paul A.', 'Dean R.', 'Marcus L.', 'Liam O.', 'Sarah W.', 'Tom H.', 'Andre K.'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPurchase({
        name: randomName,
        time: `${randomTime} min ago`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay — first popup after 30s
    const initialTimeout = setTimeout(showPopup, 30000);
    // Recurring — a new popup every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-205" data-mp="114tl294rpqca">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-3 left-3 right-3 sm:right-auto z-50 bg-white shadow-2xl border-l-2 border-neon p-3.5 flex items-center gap-3.5 sm:max-w-xs" data-id="element-206" data-mp="1fw24u1lzohhi">
          <span className="bg-neon/15 p-2.5 rounded-full text-neon-deep flex-shrink-0" data-id="element-207" data-mp="i93hihh6slwa">
            <ShoppingBag size={18} aria-hidden="true" data-id="element-208" data-mp="x5kqj21wlofo" />
          </span>
          <div data-id="element-209" data-mp="s67v3swyv91h">
            <p className="text-[0.8rem] text-gray-800" data-id="element-210" data-mp="s5onp64y031p">
              <span className="font-bold" data-id="element-211" data-mp="s8atp1c6qaht">{currentPurchase.name}</span> just
              bought the
            </p>
            <p className="text-[0.8rem] font-bold text-gray-900" data-id="element-212" data-mp="28mandukft3wm">
              Rugby 360 Box Set
            </p>
            <p className="text-[0.68rem] text-gray-500 mt-0.5" data-id="element-213" data-mp="2aotj29uehpgk">
              {currentPurchase.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}